import { useMemo } from 'react'

import { useGetBlueprintFamilyGlossaryQuery } from '../../../api/core'
import { isHtmlBlank } from '../../../helpers/string'

/**
 * Editorial blueprint family descriptions (glossary HTML) keyed by family id, for
 * hover cards. Unscoped and window-independent, so every caller shares one cache
 * entry with the Data Glossary tab.
 */
export function useBlueprintFamilyDescriptions(userLanguage: string): Map<string, string> {
  const { data: glossary } = useGetBlueprintFamilyGlossaryQuery()

  return useMemo(() => {
    const map = new Map<string, string>()
    for (const item of glossary ?? []) {
      // The backend normalizes missing translations to empty strings, and the
      // editor can leave HTML-empty ones (`<p></p>`), so fall back to English and
      // then any populated language rather than showing an empty tooltip.
      const descriptions = item.descriptions
      const resolved = descriptions
        ? [descriptions[userLanguage as keyof typeof descriptions], descriptions.en, ...Object.values(descriptions)].find((value) => !isHtmlBlank(value))
        : undefined
      if (resolved) map.set(item.id, resolved)
    }
    return map
  }, [glossary, userLanguage])
}
